import { Component, inject } from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { RouterOutlet } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent {
    constructor() {
      const angulartics2GoogleAnalytics = inject(Angulartics2GoogleAnalytics);

      angulartics2GoogleAnalytics.startTracking();
    }
}
